/**  Abstract class for a 52-card deck with methods to generate, shuffle, and value cards. */
export abstract class Card {
    public deck: string[] = [];

    public constructor() {
        this.createDeck();
    }

    /**
     * Generates a standard 52-card deck by combining card values and suits.
     * After creating the deck, it randomizes the order of the cards.
     */
    private createDeck(): void {
        const value: string[] = [
            "2", "3", "4", "5", "6", "7", "8",
            "9", "10", "J", "Q", "K", "A",
        ];
        const suits: string[] = ["♠", "♥", "♦", "♣"];

        // Loops through each suit and each value
        for (let i: number = 0; i < suits.length; i++) {
            for (let j: number = 0; j < value.length; j++) {
                this.deck.push(value[j] + suits[i]);
            }
        }

        this.shuffleDeck();
    }

    /**
     * Shuffles the deck of cards randomly.
     */
    private shuffleDeck(): void {
        for (let i: number = 0; i < this.deck.length; i++) {
            const j: number = Math.floor(Math.random() * this.deck.length);
            const temp: string = this.deck[i];
            this.deck[i] = this.deck[j];
            this.deck[j] = temp;
        }
    }

    /**
     * Returns a number value of a card
     */
    protected getValue(card: string, currentScore: number): number {
        const value: string = card.slice(0, -1);

        // Checks if value is J, K, Q or A
        if (isNaN(Number(value))) {
            if (value === "A") {
                return this.getAceValue(currentScore);
            }
            return 10;
        }
        else {
            return parseInt(value);
        }
    }

    private getAceValue(currentScore: number): number {
        if (currentScore + 11 < 21) {
            return 11;
        }
        else {
            return 1;
        }
    }
}
